<template>
  <v-dialog width="900px" v-model="dialog">
    <template #activator="{ on: dialog }">
      <v-tooltip bottom open-delay="500" color="#5774E7">
        <template #activator="{ on: tooltip, attrs }">
          <div v-on="tooltip">
            <v-btn class="mx-1 pa-2 btn" :disabled="disableAdminButton" v-on="dialog" v-bind="attrs" elevation="0" height="32px" width="32px" x-small color="white" @click="openDialog"><v-icon color="#5774E7" v-text="'mdi-auto-mode'"></v-icon> </v-btn>
          </div>
        </template>
        <span>Set the events manually and simulate</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="pl-4">
        <h3>Admin Simulator</h3>
      </v-card-title>
      <v-list outlined mandatory height="300px" class="ma-0 pa-0 overflow-y-auto">
        <v-list-item-group mandatory v-model="model" active-class="border" color="indigo">
          <v-list-item @click="clickedNewEvent()">
            <v-list-item-icon>
              <v-icon v-text="'mdi-calendar-account'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'New Event ...'"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn @click="openSave" @click.stop="" color="primary"  icon>
                <v-icon color="blue darken-4" >mdi-content-save</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider class="divider"></v-divider>
          <v-list-item  v-for="(event, i) in $store.state.simulationEvents" :key="i" @click="menuActionClick(i, event)">
            <v-list-item-icon>
              <v-icon v-text="$store.getters.eventToIcon(event)"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="$store.getters.eventToText(event)"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn @click="deleteItemEvent(i, event)" icon>
                <v-icon color="blue darken-4">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
        <v-spacer></v-spacer>
      </v-list>

      <v-card-actions class="px-5">
        <v-btn width="100px" @click="cancelButton"> Cancel </v-btn>

        <v-text-field hide-details @input="changedInput()" ref="dayInput" class="mb-1 mr-2 ml-10" v-model="dayInput" label="Day" :rules="dayInputRules" style="width: 30px; max-width: 30px"></v-text-field>
        <v-text-field hide-details @input="changedInput()" ref="hourInput" class="mb-1 mr-10" label="Hour" v-model="hourInput" :rules="hourRules" style="width: 40px; max-width: 40px"></v-text-field>

        <v-select hide-details  mandatory class="mb-1 mr-3 ml-7" label="Event Type" v-model="eventTypeModel" :items="['Hire', 'Fire', 'Train']" style="width: 90px; max-width: 90px"> </v-select>
        <v-select hide-details   mandatory @input="alteredResourceGroup()" class="mb-1 mr-3" label="Resource Group" v-model="eventResourceGroup" :items="resourceGroupNames" style="width: 90px; max-width: 90px"> </v-select>
        <v-select hide-details :disabled="eventTypeModel != 'Train'" class="mb-1" :rules="[checkAlternateGroup]" mandatory label="Alternate Group" v-model="alternateResourceGroup" :items="alternateGroupNames" style="width: 90px; max-width: 90px"> </v-select>
        <v-spacer></v-spacer>

        <v-btn width="100px" :disabled="!validAdd" @click="addEvent()"> {{ getAddLabel() }} </v-btn>
        <v-btn width="100px" :loading="loadingSim" @click="dialogSimulate = true"> Simulate </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogSimulate" max-width="400px">
      <v-card>
        <v-card-title>Simulate</v-card-title>
        <v-divider class="divider"></v-divider>
        <div class="container">
        <v-select style="width: 200px; max-width: 200px" v-model="automationMethod" mandatory class="mx-5" label="Automation Method" :items="Object.keys($store.state.SimulationOptions)" hide-details></v-select>
        <v-checkbox label="Visualise" color="indigo" v-model="visualiseResults" hide-details ></v-checkbox>

        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogSimulate = false">Close</v-btn>
          <v-btn @click="startSimulate()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <v-dialog v-model="toggle" max-width="800px">
    <AdminSave @close="closeSave" ref="adminSave"/>
  </v-dialog>
  </v-dialog>
</template>

<script>

import AdminSave from "@/components/AdminSave.vue";

export default {
  components: { AdminSave },
  mounted() {
    this.$store.state.adminSimulateComponent = this;

    this.resourceGroupNames = this.$store.state.ResourceGroups.map((group) => group.name);
    this.alteredResourceGroup();
    this.$nextTick(() => {
      if (this.$store.state.simulator != null) {
        this.disableAdminButton = this.$store.state.simulator.hoursPassed != 0;
      }
    });
    this.disableAdminButton = true;
  },
  methods: {
    checkIfAdminButtonEnabled() {
      return this.$store.state.simulator != null && this.$store.state.simulator.hoursPassed == 0;
    },
    async isValidAddEvent() {
      await this.$nextTick(() => {});
      return this.$refs.dayInput != null && this.$refs.hourInput != null && this.$refs.dayInput.validate() && this.$refs.hourInput.validate();
    },
    async addEvent() {
      //Check the rules
      var eventMapper = { Hire: "startHire", Fire: "startFire", Train: "startTrain" };
      var newEvent = { type: eventMapper[this.eventTypeModel], hour: parseInt(this.hourInput) + parseInt(8 * this.dayInput), groupName: this.eventResourceGroup, alternateGroupName: this.alternateResourceGroup };

      if (this.model == 0) {
        this.$store.state.simulationEvents.push(newEvent);
        this.clickedNewEvent();
      } else {
        this.$store.state.simulationEvents[this.model - 1] = newEvent;
        this.menuActionClick(this.model, newEvent);
        this.model = 0;
      }
      this.sortEvents();
    },
    sortEvents() {
      this.$store.state.simulationEvents.sort(function (a, b) {
        return a.hour - b.hour;
      });
    },
    async startSimulate() {
      this.dialogSimulate = false
      this.loadingSim = true;
      await this.$store.state.networkHandler.pressedRequest(this.$store.state.simulationEvents, this.automationMethod, this.visualiseResults);
      this.loadingSim = false;
      this.cancelButton();
    },
    openDialog() {
      this.model = 0;
    },
    getAddLabel() {
      if (this.model == 0) {
        return "Add";
      }

      return "Update";
    },
    async changedInput(){
      this.validAdd = await this.isValidAddEvent();
    },
    alteredResourceGroup() {
      this.alternateGroupNames = this.resourceGroupNames.filter((x) => x != this.eventResourceGroup);

      if (this.eventResourceGroup == this.alternateResourceGroup || this.alternateResourceGroup == "") {
        this.alternateResourceGroup = this.alternateGroupNames[0];
      }
    },
    menuActionClick(i, event) {
      this.alteredResourceGroup();
      var typeMapper = { startHire: "Hire", startFire: "Fire", startTrain: "Train" };
      this.dayInput = Math.floor(event.hour / 8);
      this.hourInput = event.hour - this.dayInput * 8;
      this.eventTypeModel = typeMapper[event.type];
      this.eventResourceGroup = event.groupName;
      this.alternateResourceGroup = event.alternateGroupName;
      this.changedInput();
    },
    deleteItemEvent(i, event) {
      this.$store.state.simulationEvents.splice(i, 1);
      if (this.model == 0) {
        this.clickedNewEvent();
      }
    },
    clickedNewEvent() {
      this.eventTypeModel = "Hire";
      this.eventResourceGroup = "Blue";
      this.alternateResourceGroup = "Orange";
      this.alteredResourceGroup();
      this.$refs.dayInput.reset();
      this.$refs.hourInput.reset();
      this.$nextTick(() => {
        this.dayInput = 0;
        this.hourInput = 0;
        this.changedInput();
      });
      this.model = 0;
    },
    cancelButton() {
      this.dialog = false;
    },
    openSave() {
      this.toggle = true;

      if(this.$refs.adminSave != null){
        this.$refs.adminSave.openDialog();
        }
        },
    closeSave() {
      this.toggle = false;
    },
    checkAlternateGroup(newAlternateValue) {
      return newAlternateValue != this.eventResourceGroup;
    },
  },
  watch: {
    model(val) {
      if (val == 0) {
        return this.clickedNewEvent();
      }

      this.menuActionClick(val, this.$store.state.simulationEvents[val - 1]);
    },
  },
  data: () => ({
    dialog: false,
    dialogSimulate: false,
    loadingSim: false,
    model: 0,
    validAdd: true,
    disableAdminButton: true,
    eventTypeModel: "Hire",
    resourceGroupNames: [],
    alternateGroupNames: [],
    dayInput: 0,
    toggle:false,
    hourInput: 0,
    visualiseResults: false,
    automationMethod: "EpicFlow",
    hoursPassedLocal: -1,
    eventResourceGroup: "Blue",
    alternateResourceGroup: "",
    dayInputRules: [(value) => value !== "" && value >= 0 && value < 150 && !isNaN(parseInt(value))],
    hourRules: [(value) => value !== "" && value >= 0 && value < 8 && !isNaN(parseInt(value))],
  }),
};
</script>

<style scoped>
.divider {
  border-width: 1px !important;
  border-color: rgba(55, 55, 55, 0.3) !important;
  height: 100%;
}

.btn {
  border: 1px solid #abb8f8 !important;
}

.btn {
  height: var(--simulation-button-height);
  width: var(--simulation-button-height);

  border: none;
  border-radius: 20%;
  background-color: var(--background-color);
}
</style>

<style scoped>
::-webkit-scrollbar {
  width: 10px;
}

.container{
  display: flex;
}
.select {
  width: 60px;
}
</style>
